var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sa-footer',[_c('strong',[_vm._v("Copyright © 2018.")]),_vm._v(" All rights reserved. "),_c('div',{staticClass:"float-right d-none d-sm-inline-block"},[_c('strong',[_vm._v("Version:")]),_vm._v(" "+_vm._s(_vm.version)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }